'use client';

export function ProductBadge({ name, color }: { name: string; color: string }) {
  return (
    <div
      className="flex h-[25px] items-center justify-center whitespace-nowrap rounded-full px-3 text-xs font-medium text-white"
      style={{ backgroundColor: color }}
    >
      {name}
    </div>
  );
}
